import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';
import { SubProject } from 'src/app/model/project/sub-project';
import { Adjustment } from 'src/app/model/project/adjustment';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';
import Product from 'src/app/model/product/product';
import AssetHelper from 'src/app/helpers/asset-helper';

@Component({
  selector: 'print-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentPrintDate',
      'currentConfirmedPlacementDate',
      'company',
      'detailedProductType',
      'productSize',
      'project.products.materialDisplayName',
      'printInfo',
      'printworkHandler',
      'designPhoto',
      'displayStatus',
      'star',
    ];
  }

  protected getLocalStorageKey(): string {
    return 'PrintProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/vv,Afhaling,Aanpassing,Concept,Nieuw,In_behandeling/Printwerk';
  }

  public getPageTitle(): string {
    return 'Print';
  }

  // Override
  public getDefaultSort(): string {
    return 'currentPrintDate';
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }

    super.preProcessProjects(projects);
    projects.forEach((p) => {
      p.applyGreenBackground =
        p.type === 'BaseProject'
          ? this.applyGreenBackgroundBaseProject(p)
          : this.applyGreenBackgroundAdjustment(p);
      if (p.type !== 'BaseProject' && p.projectPlacement != null) {
        AssetHelper.filterDesignAssets(
          p.projectPlacement.projectPlacementAssets
        );
      }
      if (
        p.project != null &&
        CollectionHelper.isPopulated(p.project.products)
      ) {
        p.project.products.forEach((prod) => {
          this.preprocessProduct(prod);
          AssetHelper.filterDesignAssets(prod.productAssets);
        });
      }
    });
  }

  private applyGreenBackgroundBaseProject(subProject: SubProject): boolean {
    return (
      subProject.project != null &&
      subProject.project.products != null &&
      subProject.project.products.some((p) => p != null && p.needsDesign) &&
      subProject.project.products.every(
        (p) => p == null || !p.needsDesign || p.designFinished
      )
    );
  }

  private applyGreenBackgroundAdjustment(subProject: SubProject): boolean {
    return (<Adjustment>subProject).designFinished;
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }
}
